module.exports = __webpack_public_path__ + "static/media/speech_25.72f881e3.svg";